import React, { useCallback, useState, useEffect } from 'react';
import { Cell, Spinner } from 'react-mdl';
import axios from 'axios';
import moment from 'moment';
import './index.css';
import _ from 'lodash';

import Button from '../../components/SliderButton';
import {
    BOOKING_TYPE_AIRPORT_TRANSFER,
    BOOKING_TYPE_CHAUFFEUR_SERVICES,
    BOOKING_TYPE_CAR_RENTALS,
    BOOKING_TYPE_DEPARTURE_TRANSFER,
    BOOKING_TYPE_RETURN_TRANSFER
} from '../../const'

const MainPage = (props) => {
    const [book, setBook] = useState()
    const { bId , vipType } = props.match.params
    const [isSubmitting, setSubmitting] = useState(false)
    const showDetail = useCallback(() => {
        props.history.push({
            pathname: `/${vipType ? `${vipType}/` : ''}${bId}/d`,
            state: {
                book
            }
        });
    }, [props.match, props.history, book])
    const nextStep = useCallback(() => {

        setSubmitting(true)
        navigator.geolocation.getCurrentPosition(async function (pos) {
            const geo = `${pos.coords.latitude},${pos.coords.longitude}`;
            const { bId  , vipType} = props.match.params
            const isArrival = vipType === 'arrival';
            const service = vipType === 'arrival' ? 'vip_arrival' : 'vip_departure';
            setSubmitting(false)
            const results = await axios.post(process.env.REACT_APP_API_URL + "/api/v1/partners/" + (vipType ? "greeter/" : "") + bId, {
                action: vipType ? `${vipType}_accepted` : "accepted",
                geoLocation: geo,
                isLiveLocation: true,
                ...(vipType && {
                    isArrival: isArrival,
                    service: service
                  })
            })

            props.history.push({
                pathname: `/${vipType ? `${vipType}/` : ''}${bId}/e`,
                state: {
                    book
                }
            });
        }, async function (error) {
            if (error.code === error.PERMISSION_DENIED) {
                const { bId , vipType} = props.match.params
                const isArrival = vipType === 'arrival';
                const service = vipType === 'arrival' ? 'vip_arrival' : 'vip_departure';
                const geo = `51.4933,-0.1684`;
                setSubmitting(false)
                await axios.post(process.env.REACT_APP_API_URL + "/api/v1/partners/" + (vipType ? "greeter/" : "") + bId, {
                    action: vipType ? `${vipType}_accepted` : "accepted",
                    geoLocation: geo,
                    isLiveLocation: false,
                    ...(vipType && {
                        isArrival: isArrival,
                        service: service
                      })
                })

                props.history.push({
                    pathname: `/${vipType ? `${vipType}/` : ''}${bId}/e`,
                    state: {
                        book
                    }
                });
            }
            setSubmitting(false)
        })
    }, [props.history, book, props.match])
    // const hideOnStatus = (book) => {
    //     let list = [
    //         { status: 'cancellation_requested_by_client' },
    //         { status: 'cancellation_accepted_by_agent' },
    //         { status: 'cancelled_by_agent' },
    //         // { status: 'completed' }
    //     ]
    //     const found = _.find(list, item => { return item.status === book.status });
    //     return found ? true : false
    // }
    useEffect(() => {
        async function fetchBookInfo() {
            const { bId , vipType } = props.match.params
            const result = await axios(
                process.env.REACT_APP_API_URL + "/api/v1/partners/" + bId
            );
            const acceptedStatus = vipType ? vipType === 'arrival' ? 'arrival_accepted' : 'departure_accepted' : 'accepted'
            const bookInfo = result.data.data
            if (bookInfo && bookInfo.bookingOperations.length > 0 && bookInfo.bookingOperations[0].actions.length > 0) {
                const foundAccepted = _.find(bookInfo.bookingOperations[0].actions, action => { return action.status === acceptedStatus })
                if (foundAccepted) {
                    props.history.push({
                        pathname: `/${vipType ? `${vipType}/` : ''}${bId}/e`,
                        state: {
                            book: bookInfo
                        }
                    });
                    return;
                }
            }
            setBook(result.data.data)
        }
        fetchBookInfo();
    }, [setBook, props.match, props.history])

    if (!book) {
        return (
            <div className="page-container flex-vertical justify-center text-center align-center">
                <Cell col={12}>
                    <Spinner singleColor />
                </Cell>
            </div>)
    }
    if ((book.status === "cancelled_by_agent") || (book.status === "cancellation_accepted_by_agent") || (book.status === "cancellation_requested_by_client")) {
        return (
            <div className="cancelledBookingDiv">
                <img src="/images/icons/coution.png" alt="icon coution" />
                <p >The booking was cancelled</p>
            </div>
        )
    }
    return (
        <div className="page-container landing-grid flex-vertical">
            <Cell className="flex-full" col={12}>
                <div className={`tracker-area flex ${vipType ? 'justify-end' : 'justify-between'} align-center`}>
                    {!vipType && ( <p className="new-booking-label">NEW BOOKING</p>)}
                    <p className="color-grey">#{book.number}</p>
                </div>

                <div className="booking-content">
                    <div className="car-info">
                        <p className="car-info--time">{moment.utc(vipType === 'departure' ? book?.meetAndAssist?.departure?.pickUpDate : book.pickUpDate).format("dddd Do MMMM, LT")}</p>
                       {!vipType && <p className="car-info--location">{`${book.globalVehicle.brandName} ${book.globalVehicle.modelName}`}</p>}
                       {vipType &&  <button
                      className='booking-details-link'
                      type='button'
                      onClick={showDetail}
                    >
                      View booking details
                    </button>}
                    {vipType &&  <div className='passenger-info'> <p
                      className='title'
                    >
                      Passenger
                    </p> <p
                      className='content'
                    >
                      {book?.passengerInfo?.fullName}
                    </p> </div>}
                    </div>

                    <div className="path-info">
                       <div className="location--start">
                        <div className="flex align-center">
                        {!vipType && ( <span className="material-icons long-line">
                                    stop_circle
                                </span>)}
                                <span className="title">PICK UP LOCATION</span>
                            </div>
                            <p className={`content ${vipType ? 'vip-type' : ''}`}>{vipType ? vipType === 'arrival' ? book?.pickUpLocation?.fullAddress : book?.dropOffLocation?.fullAddress : book?.pickUpLocation?.fullAddress}</p>
                        </div>
                        {book.type === BOOKING_TYPE_AIRPORT_TRANSFER || book.type === BOOKING_TYPE_DEPARTURE_TRANSFER || book.type === BOOKING_TYPE_RETURN_TRANSFER && <div className="location--end">
                            <div className="flex  align-center">
                                <span className="material-icons drop--off location">
                                    location_on
                                </span>
                                <span className="title">DROP OFF</span>
                            </div>
                            <p className="content">{book.dropOffLocation.fullAddress}</p>
                        </div>}

                        {book.type === BOOKING_TYPE_CHAUFFEUR_SERVICES && <div className="location--end">
                            <div className="flex  align-center">
                                <span className="material-icons drop--off">
                                    timer
                                </span>
                                <span className="title">DURATION</span>
                            </div>
                            <p className="content duration">{book.durationType === "hourly" ? book.duration + " hours" : `${book.days.length} days`}</p>
                        </div>}

                        {book.type === BOOKING_TYPE_CAR_RENTALS && <div className="location--end">
                            <div className="flex  align-center">
                                <span className="material-icons drop--off location">
                                    location_on
                                </span>
                                <span className="title">RENTAL PERIOD</span>
                            </div>
                            <p className="content">{moment(book.dropOffDate).diff(moment(book.pickUpDate), "days") + 1} days</p>
                        </div>}
                    </div>
                </div>
            </Cell>
            <Cell col={12}>
                <Button isLoading={isSubmitting} onClick={nextStep}>Slide to accept</Button>
                {/* <Button isLoading={isSubmitting} hide={hideOnStatus(book) ? true : false} onClick={nextStep}>Slide to accept</Button> */}
            </Cell>
        </div>
    );
}

export default MainPage;
